/*
    Register new simulation
*/
"use strict";

var simulations = require('../core/simulations.js');

module.exports = function (name, simulation) {
    simulations[name] = simulation;
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/core/register-simulation.js
 ** module id = 24
 ** module chunks = 0
 **/